// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1gK6N","productName":"Table_productName__oBR8n"};